import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
  listInward: [],
  perPageInward: "",
  totalInward: 0,
  listProcess: [],
  perPageProcess: "",
  totalProcess: 0,
  lotList: [],
};

export const getProductList = createAsyncThunk(
  "get-product",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createProduct = createAsyncThunk(
  "create-product",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("product", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const getByIdProduct = createAsyncThunk(
  "edit-product",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`product/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updateProduct = createAsyncThunk(
  "update-product",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/product/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

// Activate / deactivate a product for the app. Its own endpoint - the normal
// update expects the whole product including its variants.
export const toggleProductStatus = createAsyncThunk(
  "toggle-product-status",
  async ({ id, status }, { dispatch }) => {
    try {
      const response = await axios.patch(`product/${id}/status`, { status });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "delete-product",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const uploadProductImages = createAsyncThunk(
  "upload-product-images",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.post(`/product/${id}/images`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteProductImage = createAsyncThunk(
  "delete-product-image",
  async ({ id, filename }, { dispatch }) => {
    try {
      const response = await axios.delete(
        `/product/${id}/images/${encodeURIComponent(filename)}`,
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const reorderProductImages = createAsyncThunk(
  "reorder-product-images",
  async ({ id, images }, { dispatch }) => {
    try {
      const response = await axios.put(`/product/${id}/images/order`, {
        images,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteProductContact = createAsyncThunk(
  "delete-contact",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/contact/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const importProduct = createAsyncThunk(
  "import-product",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post(`/product/import`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const getProductInwardList = createAsyncThunk(
  "get-product-inward",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/product-inwards", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createProductInward = createAsyncThunk(
  "create-product-inward",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("product/create-product-inward", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteProductInward = createAsyncThunk(
  "delete-product-inward",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/product-inwards/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updateProductInward = createAsyncThunk(
  "update-product-inward",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/product/product-inwards/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const getProductProcessList = createAsyncThunk(
  "get-product-process",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/product-processes", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createProductProcess = createAsyncThunk(
  "create-product-process",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("product/create-product-process", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteProductProcess = createAsyncThunk(
  "delete-product-process",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/product-processes/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updateProductProcess = createAsyncThunk(
  "update-product-process",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(
        `/product/product-processes/${id}`,
        data,
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const getProductProcessLots = createAsyncThunk(
  "get-product-process-lots",
  async (variantId, { dispatch }) => {
    try {
      const response = await axios.get(`product/product-process-lots/${variantId}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.productList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getProductList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
    builder
      .addCase(importProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(importProduct.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(importProduct.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(getProductInwardList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductInwardList.fulfilled, (state, action) => {
        state.loading = false;
        state.listInward = action?.payload?.data?.data?.productList ?? [];
        state.perPageInward = +action?.payload?.data?.data?.perPage ?? 1;
        state.totalInward = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getProductInwardList.rejected, (state, action) => {
        state.loading = false;
        state.listInward = "";
        state.perPageInward = "";
        state.totalInward = "";
      });
    builder
      .addCase(getProductProcessList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductProcessList.fulfilled, (state, action) => {
        state.loading = false;
        state.listProcess = action?.payload?.data?.data?.productList ?? [];
        state.perPageProcess = +action?.payload?.data?.data?.perPage ?? 1;
        state.totalProcess = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getProductProcessList.rejected, (state, action) => {
        state.loading = false;
        state.listProcess = "";
        state.perPageProcess = "";
        state.totalProcess = "";
      });
    builder
      .addCase(getProductProcessLots.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductProcessLots.fulfilled, (state, action) => {
        state.loading = false;
        state.lotList = action?.payload?.data?.data?.lotList ?? [];
      })
      .addCase(getProductProcessLots.rejected, (state, action) => {
        state.loading = false;
        state.lotList = [];
      });
  },
});

export default productSlice.reducer;
